import { Title } from 'components';
import React from 'react';
import styled from 'styled-components';
import Loading from '@app/react-common/Loading';

const LoadingListingChat = () => (
    <StyledContainer>
      <Loading />
      <Title level={3}>Loading chat</Title>
    </StyledContainer>
  );

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
  flex: 1;
  height: 100%;
`;

export default LoadingListingChat;
